<template>
  <div class="c-pagination">
    <div v-if="showSize" class="size-buttons">
      <span>Строк:</span>

      <button
        v-for="item in sizes"
        :key="item"
        type="button"
        class="size-btn"
        :class="{ active: size === item }"
        @click="changeSize(item)"
      >
        {{ item }}
      </button>
    </div>
    <div class="pagination">
      <div class="button" @click="next(page - 1)">
        {{ '<' }}
      </div>

      <div class="button middle">
        <input
          :value="page"
          class="mini-input"
          @input="inputValue"
        >
        / {{ pages }}
      </div>

      <div class="button" @click="next(page + 1)">
        {{ '>' }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CQr',

  props: {
    pages: {
      type: Number,
      default: 10,
    },

    page: {
      type: Number,
      default: 1,
    },

    size: {
      type: Number,
      default: 20,
    },

    showSize: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      sizes: [ 20, 50, 100, ],
    }
  },

  methods: {
    inputValue(e) {
      const page = Number(e.target.value)

      if (page <= this.pages && page > 0) {
        this.$emit('update:page', page)
        this.$emit('change')
      }

      if (page > this.pages) {
        e.target.value = this.pages
        this.$emit('update:page', this.pages)
        this.$emit('change')
      }
    },

    next(page) {
      if (page <= this.pages && page > 0) {
        this.$emit('update:page', page)
        this.$emit('change')
      }
    },

    changeSize(size) {
      this.$emit('update:size', size)
    },
  },
}
</script>

<style lang="scss" scoped>
.c-pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 20px;
  position: relative;
}

.pagination {
  display: flex;
  align-items: center;
  position: absolute;
  left: 50%;
}

.mini-input {
  min-width: 10px;
  max-width: 30px;
  text-align: center;
  margin-right: 2px;
  height: 20px;
}

.button {
  cursor: pointer;
  border: 1px solid var(--primary);
  color: var(--primary);
  height: 32px;
  min-width: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 5px;
  border-radius: 8px;
  font-weight: 600;
  input {
    color: var(--primary);
    border: 1px solid var(--primary);
    border-radius: 4px;
  }
}

.middle {
  margin: 0 15px;
}

.size-buttons {
  display: flex;
  align-items: center;
  gap: 8px;

  span {
    font-size: 14px;
    color: #666;
  }
}

.size-btn {
  min-width: 42px;
  height: 32px;

  border: 1px solid var(--primary);
  border-radius: 8px;

  background: #fff;
  color: var(--primary);

  font-weight: 700;
  cursor: pointer;

  &.active {
    background: var(--primary);
    color: #fff;
  }
}
</style>
